import { ClientProfile, UserRole } from "@joonapp/web-shared"
import { useMemo } from "react"
import { useParams } from "react-router-dom"

import { useSendbird } from "../../../components/sendbird/SBProvider"
import { useCoachingGroupsQuery } from "../../../networking/coachingGroups/queries"

const useCurrentClient = () => {
  const { coachingGroupId } = useParams()
  const { data: coachingGroups } = useCoachingGroupsQuery()
  const { channels } = useSendbird()

  const currentCoachingGroup = useMemo(
    () => coachingGroups?.find((group) => group.id === Number(coachingGroupId)),
    [coachingGroups, coachingGroupId]
  )

  const currentChannel = useMemo(
    () =>
      channels?.find(
        (channel) => channel.url === currentCoachingGroup?.sendbird_channel_url
      ),
    [channels, currentCoachingGroup]
  )

  const currentClientProfile = useMemo(
    () =>
      currentCoachingGroup?.profiles.find(
        (profile) => profile.role === UserRole.CLIENT
      ) as ClientProfile | undefined,
    [currentCoachingGroup]
  )

  return {
    currentCoachingGroup,
    currentChannel,
    currentClientProfile,
  }
}

export default useCurrentClient
